"use client"

import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { Navbar, Container, Nav, Button, Offcanvas } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import logo from '../assets/images/logo.png';
import LanguageSwitcher from "./LanguageSwitcher"

function Header() {
  const { t, i18n } = useTranslation()
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  // Current language from i18n
  const currentLang = i18n.language

  const navItems = [
    { name: t("nav.home"), path: `/${currentLang}` },
    { name: t("nav.about"), path: `/${currentLang}/about` },
    { name: t("nav.services"), path: `/${currentLang}/services` },
    { name: t("nav.projects"), path: `/${currentLang}/projects` },
    { name: t("nav.contact"), path: `/${currentLang}/contact` },
  ]

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10)
    }

    // Set initial scroll state
    handleScroll()

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false)
  }, [location])

  // Update navigation items when language changes
  useEffect(() => {
    // This will trigger a re-render with updated paths when language changes
  }, [i18n.language])

  return (
    <Navbar expand="lg" fixed="top" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand as={Link} to={`/${currentLang}`}>
          <img src={logo || "/placeholder.svg"} alt="Betonbum Logo" height="50" className="d-inline-block align-top" />
        </Navbar.Brand>

        {/* Hamburger button for mobile */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setMobileMenuOpen(true)} className="d-lg-none" />

        {/* Desktop Navigation */}
        <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex justify-content-between w-100">
          {/* This empty div helps with the three-column layout */}
          <div className="invisible" style={{ width: "160px" }}></div>

          {/* Center navigation items */}
          <Nav className="mx-auto">
            {navItems.map((item) => (
              <Nav.Link as={Link} to={item.path} key={item.path} active={location.pathname === item.path}>
                {item.name}
              </Nav.Link>
            ))}
          </Nav>

          {/* Right aligned button and language switcher */}
          <div className="d-flex align-items-center">
            <LanguageSwitcher />
            <Button variant="tertiary" className="ms-3" as={Link} to={`/${currentLang}/contact`}>
              {t("nav.button")}
            </Button>
          </div>
        </Navbar.Collapse>

        {/* Mobile Navigation */}
        <Offcanvas
          show={mobileMenuOpen}
          onHide={() => setMobileMenuOpen(false)}
          placement="end"
          responsive="lg"
          className="d-lg-none"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img src={logo || "/placeholder.svg"} alt="Betonbum Logo" height="40" className="d-inline-block align-top" />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column">
              {navItems.map((item) => (
                <Nav.Link
                  as={Link}
                  to={item.path}
                  key={item.path}
                  active={location.pathname === item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="py-2"
                >
                  {item.name}
                </Nav.Link>
              ))}
            </Nav>
            <div className="mt-3 mb-3">
              <LanguageSwitcher/>
            </div>
            <div>
              <Button variant="tertiary" className="w-100" as={Link} to={`/${currentLang}/contact`}>
                {t("nav.button")}
              </Button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  )
}

export default Header
